import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const CHANNELS = [
  { key: "MyFatoorah", color: "#2D9D4D" },
  { key: "Shopify", color: "#A17E23" },
];

const RevenueOverViewReport = ({ data = [] }) => {
  const formattedData = data.map((item) => ({
    name: item.month_name,
    MyFatoorah: item.MyFatoorah || 0,
    Shopify: item.Shopify || 0,
  }));

  return (
    <div
      className="background-grpah"
      style={{
        width: "100%",
        padding: '12px',
        background: "#F1F1F8",
        borderRadius: "10px",
        boxShadow: "0 0 10px #ccc",
        height: "100%",
      }}
    >
      <div
        className="d-flex align-items-center justify-content-between w-100 pb-3 "
        style={{ columnGap: "20px" }}
      >
        <div
          className="d-flex align-items-center "
          style={{ columnGap: "30px" }}
        >
          <h5 className="w-100">Revenue Overview</h5>
        </div>

      </div>
      <div
        style={{
          width: "100%",
          background: "#F1F1F8",
          borderRadius: 10,
        }}
      >
        <ResponsiveContainer width="100%" height={200}>
          <BarChart
            data={formattedData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            {CHANNELS.map((channel) => (
                <Bar
                  key={channel.key}
                  dataKey={channel.key}
                  fill={channel.color}
                  name={channel.key}
                  radius={[10, 10, 10, 10]}
                />
              ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueOverViewReport;
